import { filtreliSablonlariGetir } from '../components/kararSablonlari/sablonFiltrele';

/**
 * Her kategori için [doğrudan, toplam] şablon sayısını hesaplar.
 *  - doğrudan: kategoriye doğrudan atanmış şablon sayısı
 *  - toplam: kategori + tüm alt kategorilerindeki BENZERSİZ şablon sayısı
 *
 * Sayımlar kategori seçiminden BAĞIMSIZDIR (faceted): yalnız etiket/kanun/arama
 * filtreleri uygulanır. Böylece bir kategori seçtiğinde diğer kategorilerin
 * sayıları sıfırlanmaz ve gezinme sırasında sabit kalır.
 */
export const hesaplaKategoriSablonSayilari = (kategoriler, sablonlar, secilenKategoriler, secilenEtiketler, secilenKanunMaddeleri, aramaMetni) => {
  const sablonSayilari = new Map();

  // Kategori seçimini yok say (boş = hepsi); yalnız etiket/kanun/arama filtreleri
  const filtrelenmis = filtreliSablonlariGetir(sablonlar, [], secilenEtiketler, secilenKanunMaddeleri, aramaMetni);

  const altKategoriIsimleri = (kategori) => {
    const isimler = new Set();
    const topla = (k) => {
      isimler.add(k.isim);
      (k.altKategoriler || []).forEach(topla);
    };
    topla(kategori);
    return isimler;
  };

  const hesaplaSayilar = (kategori) => {
    const dogrudan = filtrelenmis.filter(s =>
      Array.isArray(s.kategoriler) && s.kategoriler.some(kat => kat.isim === kategori.isim)
    ).length;

    // Bu kategori + tüm alt kategorilerindeki benzersiz şablonlar
    const altagacIsimleri = altKategoriIsimleri(kategori);
    const toplamIds = new Set();
    filtrelenmis.forEach(s => {
      if (Array.isArray(s.kategoriler) && s.kategoriler.some(kat => altagacIsimleri.has(kat.isim))) {
        toplamIds.add(s.id);
      }
    });

    sablonSayilari.set(kategori.isim, [dogrudan, toplamIds.size]);
    (kategori.altKategoriler || []).forEach(hesaplaSayilar);
  };

  kategoriler.forEach(hesaplaSayilar);

  // Kategorisiz şablonlar
  const kategorisiz = filtrelenmis.filter(s => !s.kategoriler || s.kategoriler.length === 0);
  sablonSayilari.set('Kategorisiz', [kategorisiz.length, kategorisiz.length]);

  return sablonSayilari;
};
